import clsx from "clsx";
import { Fragment } from "react";
import "./score-ui.scss";
import { EventDetail } from "src/types/eventDetail";

interface PropsI {
  score?: any
  event?: EventDetail;
}

const ScoreBoard = ({ score, event }: PropsI) => {
  if (!score || !event) return null;

  const runnArr = [
    ...(Array.isArray(score.previousOver) ? score.previousOver : []),
    ...(Array.isArray(score.currentOver) ? score.currentOver : []),
  ];

  const last6Runs = runnArr.slice(-6);

  if (event?.game_name === "cricket") {
    return (
      <div className="scorecard">
        <div className="row">
          <div className="col-12 col-md-6">
            <p className="team-1 row">
              <span className="team-name col-3">{score.teamName}</span>
              <span className="score col-6 text-end">{`${score.teamRun?.replace("/", "-")} (${score.teamOver})`}</span>
              <span className="team-name col-3">
                <span>{`CRR ${score.run_rate}`}</span>
              </span>
            </p>
            {/* <p className="team-1 row mt-2">
              <span className="team-name col-3">IND W</span>
              <span className="score col-6 text-end">198-10 (62.4)</span>
              <span className="team-name col-3"></span>
            </p> */}
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-12">
                <div className="text-xl-end">
                  {/* <span>1 | </span> */}
                  <span>{score.status2}</span>
                </div>
                <div className="row">
                  <div className="col-12">
                    <p className="text-xl-end ball-by-ball mt-2">
                      {Array.isArray(last6Runs) &&
                        last6Runs.map((run, index) => {
                          return (
                            <span
                              key={index + run}
                              className={clsx("ball-runs", {
                                four: run == "4",
                                six: run == "6",
                                wicket: ["w", "wd"].includes(run?.toLowerCase()),
                              })}
                            >
                              {run}
                            </span>
                          );
                        })}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (["soccer", "football"].includes(event.game_name?.toLowerCase())) {
    return (
      <div className="scoreUi scoreBg">
        <div className="_scoreboard2">
          <div className="team1">
            <p>{score.player1}</p>
          </div>
          <div className="_fb_time">
            <div className="time-status">{score.timeStatus}</div>
            <div className="score">{`${score.team1Score || "-"} : ${score.team2Score || "-"}`}</div>
          </div>
          <div className="team2">
            <p>{score.player2}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Fragment>
      <div className="scoreUi scoreBg">
        {["basketball", "tennis"].includes(event?.game_name ?? "") && (
          <div className="tennis">
            {event?.game_name === "tennis" && <h3>{score.timeStatus}</h3>}
            <div className="match-score">
              <div className="t1">{score.player1}</div>
              <div className="main-score">{`${score.team1Score || "0"} : ${score.team2Score || "0"}`}</div>
              <div className="t2">{score.player2}</div>
            </div>
            <hr style={{ margin: "3px 0" }} />
            {/* <div className={'_run_table' + (score.totalSet3 ? ' sets3' : ' sets2')}> */}
            <div className={"_run_table sets3"}>
              <div className="_run_table_row _run_table_head">
                <div role="heading"></div>
                <div className="cell">SETS</div>
                <div className="cell">1</div>
                <div className="cell">2</div>
                <div className="cell">3</div>
                <div className="cell">R</div>
              </div>
              <div className="_run_table_row">
                <div role="heading">{score.player1}</div>
                <div className="cell">1</div>
                <div className="cell">{score.set1[0] ?? "-"}</div>
                <div className="cell">{score.set1[1] ?? "-"}</div>
                <div className="cell">{score.set1[2] ?? "-"}</div>
                <div className="cell">{score.totalSet1}</div>
              </div>
              <div className="_run_table_row">
                <div role="heading">{score.player2}</div>
                <div className="cell">2</div>
                <div className="cell">{score.set2[0] ?? "-"}</div>
                <div className="cell">{score.set2[1] ?? "-"}</div>
                <div className="cell">{score.set2[2] ?? "-"}</div>
                <div className="cell">{score.totalSet2}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default ScoreBoard;
